export enum RequestStatus {
  Idle,
  Pending,
  Fulfilled,
  Rejected,
}
